import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const WarningTriangle = ({
  color = 'icon.arrowBlue',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 15 14' {...props}>
    <Path
      d='M7.48908 7.60691V5.17578'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M7.48843 9.56095C7.39873 9.56095 7.32592 9.63375 7.32657
          9.72345C7.32657 9.81316 7.39938 9.88596 7.48908 9.88596C7.57879
          9.88596 7.65159 9.81316 7.65159 9.72345C7.65159 9.63375 7.57879
          9.56095 7.48843 9.56095'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.8191 1.7659L13.7977 10.4789C14.3762 11.4917 13.6449 12.7521
          12.4788 12.7521H2.52157C1.35476 12.7521 0.623476 11.4917 1.20266
          10.4789L6.18126 1.7659C6.76434 0.744699 8.23602 0.744699 8.8191
          1.7659Z'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

WarningTriangle.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default WarningTriangle
